import { useFormContext } from 'react-hook-form';

export interface FieldErrorState {
	invalid: boolean;
	message?: string;
}

/**
 * Read a field's validation error uniformly. Keys the invalid state off the
 * error's *presence*, not its message — RHF sets an empty message for the
 * `required: true` / `minLength: n` shorthands. Falls back to a generic message.
 */
export function useFieldError(name: string): FieldErrorState {
	const { getFieldState, formState } = useFormContext();
	// getFieldState resolves dotted / nested field names (`errors[name]` misses `address.street`).
	const { error } = getFieldState(name, formState);
	if (!error) {
		return { invalid: false };
	}
	const message =
		typeof error.message === 'string' && error.message.length > 0
			? error.message
			: 'This field is invalid';
	return { invalid: true, message };
}
